import cn from "@/utils/class-names";
import { replaceUnderscoreDash } from "@/utils/replace-underscore-dash";
import { Badge, BadgeProps, Flex, Text, TextProps } from "rizzui";

// const statusColors = {
//     success: ["text-green-dark", "bg-green-dark"],
//     warning: ["text-orange-dark", "bg-orange-dark"],
//     danger: ["text-red-dark", "bg-red-dark"],
//     default: ["text-gray-600", "bg-gray-600"],
// };

export function DynamicBadge({
    status,
    classNameBadge,
    classNameText,
}: {
    status: string;
    classNameBadge?: BadgeProps["className"];
    classNameText?: TextProps["className"];
}) {
    const statusLower = status.toLowerCase();

    return (
        <Flex align="center" gap="2" className="w-auto">
            <Badge
                renderAsDot
                className={cn(classNameBadge ?? "bg-gray-600")}
            />
            <Text
                className={cn(
                    "font-medium capitalize",
                    classNameText ?? "text-gray-600",
                )}
            >
                {replaceUnderscoreDash(statusLower)}
            </Text>
        </Flex>
    );
}
